export enum PrePurchaseAnalyticsActionTypes {
  FETCH_REQUEST = 'prePurchaseAnalytics/FETCH_REQUEST',
  FETCH_SUCCESS = 'prePurchaseAnalytics/FETCH_SUCCESS',
  FETCH_BRAND_CONNECT_SUCCESS = 'prePurchaseAnalytics/FETCH_BRAND_CONNECT_SUCCESS',
  FETCH_ERROR = 'prePurchaseAnalytics/FETCH_ERROR',
}

export enum PrePurchaseAnalyticsType {
  VIDEO = 'video',
  POST = 'post',
  STORY = 'story',
  TIKTOK = 'tiktok',
  PINTEREST = 'pinterest',
  REEL = 'reel',
}

export interface IPrePurchaseAnalytics {
  avg_engagement?: number
  avg_engagement_pct?: number
  total_engagement?: number
  est_cpe?: number
  avg_reach?: number
  avg_reach_pct?: number
  avg_impressions?: number
  avg_impressions_pct?: number
  est_cpm?: number
  avg_video_views?: number
  avg_video_views_pct?: number
  total_video_views?: number
  avg_likes?: number
  avg_comments?: number
  avg_shares?: number
  est_cpv?: number
  avg_daily_impressions?: number
  avg_daily_engagement?: number
  avg_daily_saves?: number
  avg_save_pct?: number
  avg_daily_pin_clicks?: number
  avg_pin_click_pct?: number
  avg_daily_outbound_clicks?: number
  avg_outbound_click_pct?: number
  est_emv_multiplier?: number
  avg_emv?: number
  avg_engaged_views?: number
  avg_videos_added_playlist?: number
}

export interface IYouTubeBrandConnectMetrics {
  channel_id?: string
  channel_name?: string
  country?: string
  original_title?: string
  subscriber_count?: number
  total_video_count?: number
  total_views?: number
  total_engaged_views?: number
  total_unique_viewers?: number
  total_engagement_rate?: number
  total_likes?: number
  total_comments?: number
  total_shares?: number
  avg_views?: number
  avg_likes?: number
  avg_comments?: number
  avg_shares?: number
  avg_engagement?: number
  avg_engagement_pct?: number
  avg_impressions_rate?: number
  avg_engaged_views?: number
  avg_reach?: number
  avg_videos_added_playlist?: number
}

export interface IPrePurchaseBrandConnectAnalytics {
  channel_id: string
  period: string
  content_type: string
  followers: number
  total_comments: number
  total_engaged_views: number
  total_likes: number
  total_video_count: number
  total_impressions: number
  total_reach: number
  avg_engagement_pct: number
  avg_comments: number
  avg_engaged_views: number
  avg_likes: number
  avg_videos_added_playlist: number
  avg_impressions: number
  avg_reach: number
  updated_at: Date
}

export type PrePurchaseBrandConnectAnalyticsMetrics = Omit<
  IPrePurchaseBrandConnectAnalytics,
  'channel_id' | 'period' | 'content_type' | 'updated_at'
>

export interface IPrePurchaseAnalyticsState {
  prePurchaseAnalyticsByIdentityId: Record<
    number,
    Partial<Record<PrePurchaseAnalyticsType, IPrePurchaseAnalytics>>
  >
  brandConnectAnalyticsByIdentityId: Record<number, IPrePurchaseBrandConnectAnalytics[]>
  isFetching: boolean
  errors: any
}
